// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const OnboardingPlaybackWarning = (props: SVGProps<SVGSVGElement>) => (
	<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="m12.514 4.546 8.28 14.318a.59.59 0 0 1-.515.886H3.721a.59.59 0 0 1-.514-.886l8.279-14.318a.595.595 0 0 1 1.028 0Zm-1.894-.5a1.595 1.595 0 0 1 2.76 0l8.28 14.318c.612 1.06-.154 2.386-1.38 2.386H3.72c-1.226 0-1.992-1.326-1.38-2.386l8.28-14.319ZM12.875 14a.75.75 0 0 1-1.5 0V8a.75.75 0 0 1 1.5 0v6Zm.25 3.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
			fill="url(#OnboardingPlaybackWarning_tsx__a)"
		/>
		<defs>
			<linearGradient
				id="OnboardingPlaybackWarning_tsx__a"
				x1={2.125}
				y1={3.25}
				x2={19.498}
				y2={22.856}
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#9191FF" />
				<stop offset={1} stopColor="#F075C7" />
			</linearGradient>
		</defs>
	</svg>
);
export default OnboardingPlaybackWarning;
